import {
  FETCH_CAMPAIGN,
  FETCH_CAMPAIGN_SUCCESS,
} from '../constants';

const reducer = (state = { item: {}, loading: false }, { type, payload }) => {
  switch (type) {
    case FETCH_CAMPAIGN:
      return { item: {}, loading: true };
    case FETCH_CAMPAIGN_SUCCESS:
      return { item: payload, loading: false };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/app/campaign/reducer.js